<template>
    <div class="table-responsive">
        <table>
            <thead>
                <tr>
                    <th>Yard</th>
                    <th>CODECO IN</th>
                    <th>CODECO OUT</th>
                    <th>REC. CODECO IN</th>
                    <th>REC. CODECO OUT</th>
                    <th>MSK WS IN</th>
                    <th>MSK WS OUT</th>
                    <th>Código CODECO</th>
                    <th>Código CODECO Linea</th>
                    <th>Código ECAS</th>
                    <th>Código ECAS Linea</th>
                    <th>Código COPARN</th>
                    <th>Código COPARN Linea</th>
                </tr>
            </thead>
            <tbody>
                <tr v-show="modelValue.length === 0">
                    <td colspan="9">
                        <strong>No se ha encontrado ningún yard.</strong>
                    </td>
                </tr>
                <tr v-for="(yard, index) in modelValue" :key="yard.yard_id">
                    <td>
                        {{ yard.descripcion_yard }}
                        <input :value="yard.yard_id" type="hidden" :name="'yardParams[' + index + '][yard_id]'" :id="'yard_id' + index" /><span></span>
                    </td>
                    <td>
                        <label :for="'codeco_in' + index">
                            <input v-model="yard.codeco_in" type="checkbox" :name="'yardParams[' + index + '][codeco_in]'" :id="'codeco_in' + index" /><span></span>
                        </label>
                    </td>
                    <td>
                        <label :for="'codeco_out' + index">
                            <input v-model="yard.codeco_out" type="checkbox" :name="'yardParams[' + index + '][codeco_out]'" :id="'codeco_out' + index" /><span></span>
                        </label>
                    </td>
                    <td>
                        <label :for="'rec_codeco_in' + index">
                            <input v-model="yard.rec_codeco_in" type="checkbox" :name="'yardParams[' + index + '][rec_codeco_in]'" :id="'rec_codeco_in' + index" /><span></span>
                        </label>
                    </td>
                    <td>
                        <label :for="'rec_codeco_out' + index">
                            <input v-model="yard.rec_codeco_out" type="checkbox" :name="'yardParams[' + index + '][rec_codeco_out]'" :id="'rec_codeco_out' + index" /><span></span>
                        </label>
                    </td>
                    <td>
                        <label :for="'msk_ws_in' + index">
                            <input v-model="yard.msk_ws_in" type="checkbox" :name="'yardParams[' + index + '][msk_ws_in]'" :id="'msk_ws_in' + index" /><span></span>
                        </label>
                    </td>
                    <td>
                        <label :for="'msk_ws_in_out' + index">
                            <input v-model="yard.msk_ws_in_out" type="checkbox" :name="'yardParams[' + index + '][msk_ws_in_out]'" :id="'msk_ws_in_out' + index" /><span></span>
                        </label>
                    </td>
                    <td>
                        <div class="form-field">
                            <input-field v-model="yard.codigo_codeco" input-out :id="'codigo_codeco' + index" :name="'yardParams[' + index + '][codigo_codeco]'"></input-field>
                        </div>
                    </td>
                    <td>
                        <div class="form-field">
                            <input-field v-model="yard.codigo_linea_codeco" input-out :id="'codigo_linea_codeco' + index" :name="'yardParams[' + index + '][codigo_linea_codeco]'"></input-field>
                        </div>
                    </td>
                    <td>
                        <div class="form-field">
                            <input-field v-model="yard.codigo_ecas" input-out :id="'codigo_ecas' + index" :name="'yardParams[' + index + '][codigo_ecas]'"></input-field>
                        </div>
                    </td>
                    <td>
                        <div class="form-field">
                            <input-field v-model="yard.codigo_linea_ecas"  input-out :id="'codigo_linea_ecas' + index" :name="'yardParams[' + index + '][codigo_linea_ecas]'"></input-field>
                        </div>
                    </td>
                    <td>
                        <div class="form-field">
                            <input-field v-model="yard.codigo_coparn" input-out :id="'codigo_coparn' + index" :name="'yardParams[' + index + '][codigo_coparn]'"></input-field>
                        </div>
                    </td>
                    <td>
                        <div class="form-field">
                            <input-field v-model="yard.codigo_linea_coparn" input-out :id="'codigo_linea_coparn' + index" :name="'yardParams[' + index + '][codigo_linea_coparn]'"></input-field>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: {
        yards: {
            type: Array,
            required: false,
            default: function () {
                return [];
            }
        },
        yardParams: {
            type: Array,
            required: false,
            default: function () {
                return [];
            }
        }
    },
    data: function () {
        return {
            modelValue: []
        };
    },
    methods: {
        organizarArray: function () {
            for (let i = 0 ; i < this.yards.length; i++) {
                let yard = {
                    yard_id: this.yards[i].code,
                    descripcion_yard: this.yards[i].nombre,
                    codeco_in: false,
                    codeco_out: false,
                    msk_ws_in: false,
                    msk_ws_in_out: false,
                    codigo_codeco: '',
                    codigo_linea_codeco: '',
                    codigo_ecas: '',
                    codigo_linea_ecas: '',
                    codigo_coparn: '',
                    codigo_linea_coparn: '',
                    rec_codeco_in: false,
                    rec_codeco_out: false
                };
                for (let j = 0; j < this.yardParams.length; j++) {
                    if (this.yards[i].code == this.yardParams[j].yard_id) {
                        yard.codeco_in = this.yardParams[j].codeco_in === 'S';
                        yard.codeco_out = this.yardParams[j].codeco_out === 'S';
                        yard.msk_ws_in = this.yardParams[j].msk_ws_in === 'S';
                        yard.msk_ws_in_out = this.yardParams[j].msk_ws_in_out === 'S';
                        yard.codigo_codeco = this.yardParams[j].codigo_codeco;
                        yard.codigo_linea_codeco = this.yardParams[j].codigo_linea_codeco;
                        yard.codigo_ecas = this.yardParams[j].codigo_ecas;
                        yard.codigo_linea_ecas = this.yardParams[j].codigo_linea_ecas;
                        yard.codigo_coparn = this.yardParams[j].codigo_coparn;
                        yard.codigo_linea_coparn = this.yardParams[j].codigo_linea_coparn;
                        yard.rec_codeco_in = this.yardParams[j].rec_codeco_in === 'S';
                        yard.rec_codeco_out = this.yardParams[j].rec_codeco_out === 'S';
                        break;
                    }
                }
                this.modelValue.push(yard);
            }
        }
    },
    mounted: function () {
        this.organizarArray();
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/clientes/ParametrosEnvioRecepcion.vue